import { render, staticRenderFns } from "./driverWithdrawal.vue?vue&type=template&id=60b1b988&scoped=true"
import script from "./driverWithdrawal.vue?vue&type=script&lang=js"
export * from "./driverWithdrawal.vue?vue&type=script&lang=js"
import style0 from "./driverWithdrawal.vue?vue&type=style&index=0&id=60b1b988&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b1b988",
  null
  
)

export default component.exports